// src/utils/bem.ts
export interface BemModifiers {
  [key: string]: boolean | string | number | undefined | null;
}

export const VueBemCn = (block: string) => {
  const b = (): string => block;

  const e = (element: string, modifiers: BemModifiers = {}): string => {
    const base = `${block}__${element}`;
    const mods = Object.entries(modifiers)
      .filter(([_, value]) => Boolean(value))
      .map(([mod, value]) => {
        // If value is a string, combine key and value
        if (typeof value === 'string') {
          return `${base}--${mod}-${value}`;
        }
        // Otherwise use the key as the modifier name
        return `${base}--${mod}`;
      });

    return [base, ...mods].join(" ");
  };

  const m = (modifiers: BemModifiers = {}): string => {
    const mods = Object.entries(modifiers)
      .filter(([_, value]) => Boolean(value))
      .map(([mod, value]) => {
        // If value is a string, combine key and value
        if (typeof value === 'string') {
          return `${block}--${mod}-${value}`;
        }
        // Otherwise use the key as the modifier name
        return `${block}--${mod}`;
      });
    
    return [block, ...mods].join(" ");
  };

  return { b, e, m };
};
